import { useMemo } from "react";

import { useAppSelector } from "app/hooks";
import {
  selectAuthScheme,
  selectCurrentPractice,
  selectCurrentUser,
  selectCurrentUserToken
} from "features/auth/auth-slice";

import {
  ActiveSessionContext,
  computeActiveSessionContext
} from "./practice-session-context.util";

/**
 * Derives the practice-session persona from the Bearer token's claims plus the
 * actor's groups and the active practice in state. Drives the context banner.
 */
export default function useActiveSessionContext(): ActiveSessionContext {
  const token = useAppSelector(selectCurrentUserToken);
  const scheme = useAppSelector(selectAuthScheme);
  const currentUser = useAppSelector(selectCurrentUser);
  const currentPractice = useAppSelector(selectCurrentPractice);

  return useMemo(
    () =>
      computeActiveSessionContext({
        token,
        scheme,
        groupNames: (currentUser?.groups ?? []).map((group) => group.name),
        activePracticeId: currentPractice?.id ?? null,
        activePracticeName: currentPractice?.name ?? null
      }),
    [token, scheme, currentUser, currentPractice]
  );
}
